// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";

const defaultSetRoute = {}

const routes = (process.env.VUE_APP_PACKAGE !== 'intuit.portal') ? [] : [
    {
        path: 'dealer/:pathMatch(.*)?',
        name: consts.routerNames.dealer.main,
        meta: {
            mainRouteName: consts.routerNames.dealer.main,
            hideMap: true,
            pageClass: 'hide-map',
            isLimited: true,
            layers: consts.defaultSettingsLayers,
            setRoute: defaultSetRoute,
        },
        component: () => import('@/views/intuit/portal/DealerPage.vue')
    },
];

export default routes;